/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetCrmExistingCategoryRecordForTefanawwal Input Action
 */

export interface IExistingCategoryDataActionInput {
    token: string,
    emiratesID: string,
}
export interface IGetCrmCategoryIdsForTefanawwalData {
    categoryID: string;
    categoryNameArabic: string;
    categoryNameEnglish: string;
    emiratesID: string;
    hqID: string

}
export class GetCrmExistingCategoryRecordForTefanawwalInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public token: string | undefined;
    public emiratesID: string | undefined;
    constructor(data: IExistingCategoryDataActionInput) {
        this.token = data.token;
        this.emiratesID = data.emiratesID;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GETEXISTINGCATEGORYRECORD`;
    public getCacheObjectType = () => 'GETEXISTINGCATEGORYRECORD';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCrmExistingCategoryRecordForTefanawwalData {
    status: boolean,
    data: IGetCrmCategoryIdsForTefanawwalData[] | undefined,
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createExistingCategoryRecordInput = (args: Msdyn365.ICreateActionContext,inputData:IExistingCategoryDataActionInput ): Msdyn365.IActionInput => {
    return new GetCrmExistingCategoryRecordForTefanawwalInput(inputData);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getExistingCategoryRecordAction(input: GetCrmExistingCategoryRecordForTefanawwalInput, ctx: Msdyn365.IActionContext): Promise<IGetCrmExistingCategoryRecordForTefanawwalData> {
    const token = input.token;
    const szfCRMDomainForTefanAwwal = ctx.requestContext.app.config.szfCRMDomainForTefanAwwal;
    const data = { 
        "ActionName": "GetEmiratesById",
        "EmiratesID": input.emiratesID ? `${input.emiratesID}` : ''
    }
    const response = await Msdyn365.sendRequest<any>(`${szfCRMDomainForTefanAwwal}/api/data/v9.2/sys_Invoke`, "post", data, {
        headers: {
            'Authorization':`Bearer ${token}`
        }
    });
    console.log('response',response)
    
    if(response && response.data && response.data.ResponseMessage && response.data.ResponseMessage.length > 0){
        const responseInJson = JSON.parse(response.data.ResponseMessage)
        return {
            status: true,
            data: responseInJson
        };
    }else{
        return {
            status: false,
            data: undefined
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCrmExistingCategoryRecordForTefanawwalData>>getExistingCategoryRecordAction,
    // TODO: Give your data action a unique id
    id: 'GetCrmExistingCategoryRecordForTefanawwal',
    input: createExistingCategoryRecordInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
